<template>
  <div id="HomePage">
    <!-- <md-toolbar class="md-primary"> -->
      <!-- <span class="md-title">My Title</span> -->
      <Header/>

      <!-- <div class="md-toolbar-section-end"> -->
        <md-button @click="showSidepanel = true">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-list" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="color: white; font-size: 35px;">
          <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg>
        </md-button>
      <!-- </div> -->
    <!-- </md-toolbar> -->
    <md-drawer class="md-right" :md-active.sync="showSidepanel">
      <md-list>
        <md-list-item>
          <button v-if="!checkDaneAdresowe" class="btn" @click="showInfo = true, showSidepanel = false">{{$t('message.zapisz')}}</button>
          <button v-else class="btn" @click="save_file">{{$t('message.zapisz')}}</button>
        </md-list-item>
        <md-list-item>
        <div class="upload-btn-wrapper">
          <button class="btn">{{$t('message.otworz')}}</button>
          <!-- <input type="file" name="myfile" /> -->
          <input type="file" name="myfile" @change="onFileChange" accept='application/json'>
        </div>
        </md-list-item>

        <!-- <md-list-item>
          <button class="btn">Drukuj</button>
        </md-list-item> -->
        <md-list-item>
          <button class="btn" @click="showDialogInfoProgram = !showDialogInfoProgram, showSidepanel = false">{{$t('message.o_programie')}}</button>
        </md-list-item>

        <md-list-item>
          <button class="btn" @click="openLink()">{{$t('message.instrukcja_programu')}}</button>
        </md-list-item>
      </md-list>
      <hr>
      <md-list>
        <md-list-item>
          <button class="btn" onclick="window.open('https://www.pulsar.pl/PL_848_dokumenty', '_blank');">{{$t('message.dokumentacja')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="showDialogDaneAdresowe = !showDialogDaneAdresowe, showSidepanel = false">{{$t('message.dane_adresowe')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="showDialogZapytanie = !showDialogZapytanie, showSidepanel = false">{{$t('message.wyslij_zapytanie')}}</button>
        </md-list-item>
      </md-list>
    </md-drawer>

    <md-content>
      <Content/>
    </md-content>

    <InfoProgram
      :showDialog="showDialogInfoProgram"
      @clickedClose="closedDialog"
    />
    <DaneAdresowe
      :showDialog="showDialogDaneAdresowe"
      @clickedClose="closedDialog"
    />
    <Zapytanie
      :showDialog="showDialogZapytanie"
      @clickedClose="closedDialog"
    />

    <md-dialog :md-active.sync="showInfo" :md-click-outside-to-close="false" :md-close-on-esc="false">

      <div style="width:100%; padding:5px">
      <md-button class="md-primary" style="position: relative; width: 80px; float: right;" @click="closeInfo(0)">{{$t('message.zamknij')}}</md-button>
      </div>
      <diV>
      </diV>
        <div id="content" style="width: 440px;margin: 10px 20px;font-size: 16px;text-align: center;line-height: 25px;">
        Przed zapisaniem, uzupełnij dane teleadresowe.<br><b>Zamówienia przyjmowane są<br>tylko z danymi teleadresowymi</b>.
        </div>
      <md-dialog-actions>
        <md-button class="md-primary" style="position: absolute;left: 10px;top: 0px;" @click="closeInfo(2)">UZUPEŁNIJ DANE</md-button>
        <md-button class="md-primary" style="position: absolute;right: 10px;top: 0px;float: right;" @click="closeInfo(1)">ZAPISZ BEZ DANYCH</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

import Content from './Content'
import Header from './Header'
import InfoProgram from './Dialogs/InfoProgram'
import DaneAdresowe from './Dialogs/DaneAdresowe'
import Zapytanie from './Dialogs/Zapytanie'

export default {
  name: 'Temporary',
  mixins: [app, materials, calculation],
  data: () => ({
    fileOpen: {},
    showInfo: false,
    showSidepanel: false,
    showDialogInfoProgram: false,
    showDialogDaneAdresowe: false,
    showDialogZapytanie: false
  }),
  components: {
    Header, Content, InfoProgram, DaneAdresowe, Zapytanie
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy']),

    checkDaneAdresowe () {
      // this.outputs.zamawiajacy.nazwa email
      // this.outputs.inwestycja.nazwa email
      return this.outputs.zamawiajacy.nazwa !== '' && this.outputs.zamawiajacy.email !== '' && this.outputs.inwestycja.nazwa !== '' && this.outputs.inwestycja.email !== ''
    }

  },
  methods: {
    openLink () {
      const url = `https://lib.pulsar.pl/doc/instrukcja/confi-dso_${this.$i18n.locale.toUpperCase()}.pdf`
      // const url = `https://example.com/profile/${userId}`
      window.open(url, '_blank')
    },
    closedDialog (bool) {
      this.showDialogInfoProgram = bool
      this.showDialogDaneAdresowe = bool
      this.showDialogZapytanie = bool
    },
    closeInfo (value) {
      this.showInfo = false
      if (value === 0) {
      } else if (value === 1) {
        this.save_file()
      } else if (value === 2) {
        this.showDialogDaneAdresowe = true
      }
    },
    save_file () {
      var json = {
        'inputs': this.inputs,
        'outputs': this.outputs,
        'rabat': this.outputs.rabat
      }
      var plik = ''
      var dzis = new Date().toLocaleDateString()

      if (this.outputs.nazwaPliku && this.outputs.nazwaPliku.value && this.outputs.nazwaPliku.value !== '') {
        plik = this.outputs.nazwaPliku.value
      } else {
        plik = dzis + '_confi-dso'
      }
      const data = JSON.stringify(json)
      var FileSaver = require('file-saver')
      var blob = new Blob([data], {type: 'application/json;charset=utf-8'})
      FileSaver.saveAs(blob, plik + '.json')
      self.showSidepanel = false
    },
    onFileChange (e) {
      const file = e.target.files[0]
      const reader = new FileReader()
      var self = this

      this.$store.commit('app/CLEAR_INPUTS')
      this.$store.commit('app/CLEAR_OUTPUTS')

      reader.onload = (function (f) {
        return function (e) {
          // console.log(JSON.parse(e.target.result))
          self.fileOpen = JSON.parse(e.target.result)
          self.showSidepanel = false
          self.change_value_state(self.fileOpen)
        }
      })(file)
      reader.readAsText(file)
    },
    change_value_state (items) {
      if (Object.keys(items.rabat).length > 0) {
        this.changeValueOutputs('rabat', 'value', items.rabat.value)
      }
      if (Object.keys(items.inputs).length > 0) {
        Object.keys(items.inputs).forEach(element => {
          if (items.inputs[element].value !== 0) {
            this.changeValueInputs(element, 'value', items.inputs[element].value)
          }
          if (element === 'glebokosc_szafy') {
            if (items.inputs[element].active) {
              this.changeValueInputs(element, 'value', items.inputs[element].value)
              this.changeValueInputs(element, 'active', true)
            }
          }
        })
      }
      if (Object.keys(items.outputs).length > 0) {
        if (items.outputs['zamawiajacy']) {
          this.changeValueOutputs('zamawiajacy', 'array', items.outputs['zamawiajacy'])
        }
        if (items.outputs['inwestycja']) {
          this.changeValueOutputs('inwestycja', 'array', items.outputs['inwestycja'])
        }
        if (items.outputs['wysylka']) {
          this.changeValueOutputs('wysylka', 'array', items.outputs['wysylka'])
        }
      }

      this.obliczenia_sprzetu()
      // console.log(items.rabat)
    }
  },
  created () {

  }
}
</script>

<style scoped>
#HomePage {
  background: #efefef;
  overflow: hidden;
}
button.md-button {
  position: absolute;
  top: 10px;
  right: 5px;
}
#HomePage .md-drawer {
  width: 215px;
  background: #0c3351 !important;
}
#HomePage .md-list {
  background: #0c3351 !important;
}
#HomePage .md-list li:hover{
  background: #061f33 !important;
  margin: 0px 0px;
}
#HomePage .md-list li:hover button{
  color: #07b9ff;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  border: 0px solid gray;
  border-radius: 0px;
}

.btn {
  color: gray;
  background: none;
  padding: 2px 4px;
  font-size: 15px;
  font-weight: bold;
  color:#fff;
  font-weight: normal;
}

.upload-btn-wrapper input[type=file] {
  font-size: 23px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue